import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20futuristic%20gaming%20arcade%20environment%20with%20neon%20orange%20and%20warm%20gold%20accents%2C%20abstract%20geometric%20shapes%20floating%2C%20digital%20game%20controller%20silhouette%2C%20energetic%20atmosphere%2C%20dark%20background%20with%20glowing%20highlights%2C%20modern%20tech%20aesthetic%2C%20clean%20composition&width=1800&height=900&seq=hero-pg-simulator-main&orientation=landscape"
        alt="PG模拟器 - 免费在线游戏模拟平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="PG模拟器 - 免费在线游戏模拟平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4">
        <span className="inline-block px-4 py-1.5 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 text-primary-200 text-sm font-medium rounded-full mb-6 whitespace-nowrap">
          <i className="ri-sparkling-line mr-1.5"></i>2026年最受欢迎的在线游戏模拟平台
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-5 leading-tight">
          免费在线体验
          <span className="text-primary-400">PG游戏模拟</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          PG模拟器是专为游戏爱好者打造的在线模拟体验平台，无需下载即可免费试玩PG系列游戏。
          支持多设备运行，画面流畅，操作简单。随时随地畅玩无阻。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/jingdian"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-heading text-lg rounded-full whitespace-nowrap cursor-pointer transition-all hover:scale-105"
          >
            <i className="ri-gamepad-line mr-2"></i>立即免费体验
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full whitespace-nowrap cursor-pointer transition-all"
          >
            <i className="ri-information-line mr-2"></i>了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10 flex-wrap">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-white">200+</div>
            <div className="text-xs text-white/60 mt-1">精品游戏</div>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-white">50万+</div>
            <div className="text-xs text-white/60 mt-1">活跃玩家</div>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-white">4.9</div>
            <div className="text-xs text-white/60 mt-1">玩家评分</div>
          </div>
        </div>
      </div>
    </section>
  );
}